import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppStateService } from "../services/app-state/app-state.service";

@Injectable({
  providedIn: "root",
})
export class AuthGaurd {
  constructor(
    private appStateService: AppStateService,
    private router: Router
  ) {}
  canActivate(
    _route: ActivatedRouteSnapshot,
    _router: RouterStateSnapshot
  ): boolean | UrlTree | Promise<boolean | UrlTree> | Observable<boolean | UrlTree> {
    // Route guarding is always backed by a real check against the `ab_session`
    // cookie (via AppStateService, not a synchronous localStorage/BehaviorSubject
    // read) so a stale client-side flag can never let a route through.
    return this.appStateService.checkSession().pipe(
      map((isAuthenticated) => {
        if (isAuthenticated) {
          return true;
        }
        return this.router.createUrlTree(["/login"]);
      })
    );
  }
}
